import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumnBreak12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextColumnBreak12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 0a1 1 0 0 0-1 1v9H3.5a.5.5 0 0 0 0 1H5a1 1 0 0 0 1-1V1h1.5a.5.5 0 0 0 0-1zM.5 2a.5.5 0 0 0 0 1H3a.5.5 0 0 0 0-1zM0 6.5A.5.5 0 0 1 .5 6H3a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5M.5 4a.5.5 0 0 0 0 1H2a.5.5 0 0 0 0-1zM0 8.5A.5.5 0 0 1 .5 8H2a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5m8.5-6A.5.5 0 0 1 9 2h2.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5m0 4A.5.5 0 0 1 9 6h2.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M9 4a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1zm-.5 4.5A.5.5 0 0 1 9 8h1.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumnBreak12);
